import { useLayoutEffect, useRef } from 'react';

import { usePageExport } from '../Chart/chart-menu/PageExportProvider';
import { ReportWrapper } from '../ContentGrid/ReportWrapper';
import {
  DEFAULT_GRID_COLUMNS,
  DEFAULT_GRID_ROWS,
} from '../PageConfigProvider/constants';
import {
  usePageConfig,
  useTabContentConfig,
} from '../PageConfigProvider/PageConfigProvider';
import { PageType } from '../PageConfigProvider/types';
import { scrollPositionStore } from '../scroll-position-store';
import { DashboardEditableGrid } from './DashboardEditableGrid';
import styles from './EditableGrid.module.css';
import { GridProvider } from './GridProvider';
import { ReportEditableGrid } from './ReportEditableGrid';

interface EditableGridProps {
  onBuilderOpenChange?: (isOpen: boolean) => void;
}

export const EditableGrid = ({ onBuilderOpenChange }: EditableGridProps) => {
  const { config: pageConfig } = usePageConfig();
  const { config, items } = useTabContentConfig();
  const { pdfExportRef } = usePageExport();

  const isReport = pageConfig.type === PageType.REPORT;
  const gridRows = config.grid?.rows ?? DEFAULT_GRID_ROWS;
  const gridColumns = config.grid?.columns ?? DEFAULT_GRID_COLUMNS;
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const gridContainerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    scrollPositionStore.restore(scrollContainerRef.current);
  }, []);

  return (
    <div
      ref={scrollContainerRef}
      onScroll={(e) => scrollPositionStore.save(e.currentTarget)}
      data-report={isReport}
      className={styles.scrollContainer}
    >
      <ReportWrapper isReport={isReport}>
        <div ref={pdfExportRef} className={styles.pdfExportRoot}>
          <GridProvider
            items={items}
            gridRows={gridRows}
            gridColumns={gridColumns}
            isReport={isReport}
            gridContainerRef={gridContainerRef}
          >
            {isReport ? (
              <ReportEditableGrid
                onBuilderOpenChange={onBuilderOpenChange}
                gridContainerRef={gridContainerRef}
              />
            ) : (
              <DashboardEditableGrid
                onBuilderOpenChange={onBuilderOpenChange}
                gridContainerRef={gridContainerRef}
              />
            )}
          </GridProvider>
        </div>
      </ReportWrapper>
    </div>
  );
};
